<template>
  <Modal :id="id" title="Included Courses">
    <div slot="body" class="modal-body">
      <div class="row">
        <div class="col-12 py-1">
          <p>
            The following course(s) are included with this event at no additional cost. These course(s) should be completed prior to attending the event.
          </p>
          <ul class="mt-4 included-courses" :class="self ? 'self' : 'others'">
            <li v-for="course in event.included_courses">
              <p class="my-1">
                <div class="included-icon icon-check mr-2" :class="course.is_registered ? 'registered' : 'not-registered'"></div>
                {{ course.name }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-primary mr-auto" href="#" @click="enroll">Continue Registration</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Close</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "included-courses-notice-modal",
      event: null,
      self: false,
    };
  },
  methods: {
    enroll() {
      this.goToRoute(
          this.self ? "enroll.classroom.event.self" : "enroll.classroom.event.others",
          { event: this.event.id }
      );
    }
  },
  created() {
    this.event = this.options.event;
    this.self = !!this.options.self || false;
  }
};
</script>
<style lang="scss" scoped>
@import "sass/_variables";
.included-courses.others {
  .included-icon:before { display: none; }
}
.included-courses.self {
  list-style-type: none;
  .included-icon {
    background-color: $secondary;
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    &:before {
      opacity: 0;
      position: relative;
    }
    &.registered {
      background-color: $primary;
      &:before {
        opacity: 1;
        font-size: 8px;
        margin-left: 3px;
        color: white;
        bottom: 3px;
      }
    }
  }
}
</style>